(() => {
  if (window.omsInfiniteScrollStarted) return;
  window.omsInfiniteScrollStarted = true;

  let activeGrid;
  let observer;
  let controller;

  function getNextPageUrl(pagination) {
    if (!pagination) return null;

    const currentItem = pagination.querySelector(
      '[aria-current="page"]'
    );

    const currentPage = Number(
      currentItem?.textContent.trim()
    );

    if (!currentPage) return null;

    const nextLink = Array.from(
      pagination.querySelectorAll('a[href]')
    ).find(link => {
      const url = new URL(
        link.href,
        window.location.origin
      );

      return (
        Number(url.searchParams.get('page')) ===
        currentPage + 1
      );
    });

    return nextLink?.href || null;
  }

  function initialise() {
    const grid = document.querySelector(
      '#ProductGridContainer #product-grid'
    );

    // Reinitialise when Dawn replaces the product grid.
    if (grid === activeGrid) return;

    observer?.disconnect();
    controller?.abort();
    activeGrid = grid;

    if (!grid) return;

    const container = grid.closest(
      '#ProductGridContainer'
    );

    container.querySelectorAll(
      '[data-infinite-scroll-status]'
    ).forEach(element => element.remove());

    const pagination = container.querySelector(
      '.pagination-wrapper'
    );

    if (!pagination) return;

    let nextUrl = getNextPageUrl(pagination);

    if (!nextUrl) return;

    pagination.hidden = false;

    controller = new AbortController();
    const requestController = controller;

    let loading = false;
    let stopped = false;

    const status = document.createElement('p');
    status.setAttribute(
      'data-infinite-scroll-status',
      ''
    );
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.style.textAlign = 'center';

    pagination.before(status);

    async function loadNext() {
      if (loading || stopped || !nextUrl) return;

      loading = true;
      grid.setAttribute('aria-busy', 'true');
      status.textContent = 'Loading more products…';

      try {
        const response = await fetch(nextUrl, {
          signal: requestController.signal
        });

        if (!response.ok) {
          throw new Error('Unable to load next page');
        }

        const html = await response.text();

        const page = new DOMParser().parseFromString(
          html,
          'text/html'
        );

        const incomingGrid = page.querySelector(
          '#ProductGridContainer #product-grid'
        );

        if (!incomingGrid) {
          throw new Error('Product grid not found');
        }

        // Ignore results from an old filter or sort selection.
        if (
          requestController.signal.aborted ||
          document.querySelector(
            '#ProductGridContainer #product-grid'
          ) !== grid
        ) {
          return;
        }

        const cards = Array.from(
          incomingGrid.children
        );

        if (!cards.length) {
          throw new Error('No product cards found');
        }

        const incomingPagination = page.querySelector(
          '#ProductGridContainer .pagination-wrapper'
        );

        const followingUrl = getNextPageUrl(
          incomingPagination
        );

        cards.forEach(card => {
          // Display appended cards without waiting for animation.
          card.classList.remove(
            'scroll-trigger',
            'animate--slide-in',
            'scroll-trigger--offscreen'
          );

          grid.appendChild(card);
        });

        if (incomingPagination) {
          pagination.innerHTML =
            incomingPagination.innerHTML;
        }

        nextUrl = followingUrl;
        status.textContent = '';

        if (!nextUrl) {
          stopped = true;
          localObserver.disconnect();
          pagination.hidden = true;
          status.textContent =
            'You’ve reached the end.';
        } else {
          // Check again after the newly added cards appear.
          localObserver.unobserve(pagination);

          requestAnimationFrame(() => {
            if (
              !stopped &&
              !requestController.signal.aborted
            ) {
              localObserver.observe(pagination);
            }
          });
        }
      } catch (error) {
        if (error.name === 'AbortError') return;

        stopped = true;
        localObserver.disconnect();
        pagination.hidden = false;

        status.textContent =
          'Please use the page links below to continue.';

        console.warn(
          'Collection infinite scroll:',
          error
        );
      } finally {
        loading = false;
        grid.removeAttribute('aria-busy');
      }
    }

    const localObserver = new IntersectionObserver(
      entries => {
        if (
          entries.some(entry => entry.isIntersecting)
        ) {
          loadNext();
        }
      },
      {
        rootMargin: '0px 0px 400px 0px'
      }
    );

    observer = localObserver;
    localObserver.observe(pagination);
  }

  function start() {
    initialise();

    new MutationObserver(initialise).observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start
    );
  } else {
    start();
  }
})();
